import DashboardIcon from "@mui/icons-material/Dashboard";
import UserIcon from "@mui/icons-material/Person";
import SettingsIcon from "@mui/icons-material/Settings";
import HomeIcon from "@mui/icons-material/Home";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import GroupIcon from "@mui/icons-material/Group";
import BusinessIcon from "@mui/icons-material/Business";
import SecurityIcon from "@mui/icons-material/Security";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import StorefrontIcon from "@mui/icons-material/Storefront";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import InventoryIcon from "@mui/icons-material/Inventory";
import SellIcon from "@mui/icons-material/Sell";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import PeopleIcon from "@mui/icons-material/People";

export const NAVIGATION_CONFIG = [
  {
    segment: "dashboard",
    title: "Tableau de bord",
    icon: DashboardIcon,
    requiredPermission: "dashboard",
  },
  {
    segment: "welcome",
    title: "Bienvenue",
    icon: HomeIcon,
    requiredPermission: "welcome",
  },
  {
    segment: "ventes",
    title: "Gestion des Ventes",
    icon: SellIcon,
    children: [
      {
        segment: "client",
        title: "Clients",
        icon: GroupIcon,
        requiredPermission: "client",
      },
      {
        segment: "vente",
        title: "Ventes",
        icon: PointOfSaleIcon,
        requiredPermission: "vente",
      },
      {
        segment: "confirmation",
        title: "Confirmation",
        icon: SettingsIcon,
        requiredPermission: "confirmation",
      },
      {
        segment: "installment-details",
        title: "Installment Details Page",
        icon: SettingsIcon,
        requiredPermission: "installment-details",
      },
      {
        segment: "refund",
        title: "Remboursement",
        icon: SettingsIcon,
        requiredPermission: "refund",
      },
      {
        segment: "facture",
        title: "Factures",
        icon: StorefrontIcon,
        requiredPermission: "facture",
      },
    ],
  },
  {
    segment: "achats",
    title: "Gestion des Achats",
    icon: ShoppingBasketIcon,
    children: [
      {
        segment: "fournisseur",
        title: "Fournisseurs",
        icon: LocalShippingIcon,
        requiredPermission: "fournisseur",
      },
      {
        segment: "achat",
        title: "Achats",
        icon: ShoppingCartIcon,
        requiredPermission: "achat",
      },
    ],
  },
  {
    segment: "inventaire",
    title: "Inventaire",
    icon: InventoryIcon,
    children: [
      {
        segment: "article",
        title: "Article",
        icon: DashboardIcon,
        requiredPermission: "article",
      },
    ],
  },
  {
    segment: "users-config",
    title: "Utilisateurs et Configuration",
    icon: PeopleIcon,
    children: [
      {
        segment: "utilisateur",
        title: "Utilisateurs",
        icon: UserIcon,
        requiredPermission: "utilisateur",
      },
      {
        segment: "profile",
        title: "Profiles",
        icon: SupervisorAccountIcon,
        requiredPermission: "profile",
      },
      {
        segment: "permissions",
        title: "Permissions",
        icon: SecurityIcon,
        requiredPermission: "permissions",
      },
      {
        segment: "roles",
        title: "Rôles",
        icon: SecurityIcon,
        requiredPermission: "roles",
      },
      {
        segment: "tiers",
        title: "Tiers",
        icon: BusinessIcon,
        requiredPermission: "tiers",
      },
      {
        segment: "categories",
        title: "Categories",
        icon: BusinessIcon,
        requiredPermission: "categories",
      },
    ],
  },
];
